import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const clearSession = () => {
    setUser(null);
    localStorage.removeItem('app_user');
    localStorage.removeItem('auth_token');
  };

  // Rehydrate the session by validating the stored token with the backend
  useEffect(() => {
    const savedToken = localStorage.getItem('auth_token');
    if (!savedToken) {
      setIsLoading(false);
      return undefined;
    }
    let active = true;
    authService
      .me(savedToken)
      .then((me) => {
        if (!active) return;
        setUser({ username: me.username, role: me.role });
        localStorage.setItem('app_user', me.username);
      })
      .catch(() => {
        if (active) clearSession();
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const login = (username, token, role) => {
    setUser({ username, role });
    localStorage.setItem('app_user', username);
    if (token) {
      localStorage.setItem('auth_token', token);
    }
  };

  const logout = clearSession;

  const isLoggedIn = !!user;

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
